/**
 * Turn a 402 detail from the API into the locked-feature banner's content,
 * or null when it isn't one of the two plan/subscription refusals.
 *   service_not_entitled  — the org's subscription doesn't cover the service
 *   plan_feature_required — the org's plan doesn't include this feature
 */
const PLAN_NAMES = { solo: 'Solo', team: 'Team', business: 'Business', concierge: 'Lead Concierge' };

export function lockFromError(detail) {
  if (!detail || typeof detail !== 'object') return null;
  if (detail.code === 'service_not_entitled') {
    return {
      title: `${detail.service_key || 'This service'} is locked`,
      message: detail.message,
      service_key: detail.service_key,
    };
  }
  if (detail.code === 'plan_feature_required') {
    const plan = PLAN_NAMES[detail.required_plan] || detail.required_plan;
    return {
      title: plan ? `Available on ${plan}` : 'Not included in your plan',
      message: detail.message,
      feature: detail.feature,
    };
  }
  return null;
}
